import { isBefore } from "date-fns"
import { z } from "zod"
import { CertificateType } from "@/modules/patients/detail/sick-leave-certificate/de/services/__generated__/useDeCreateSickLeaveMutation.graphql"

export const SickLeaveCertificateSchema = z.object({
  typeOfCertificate: z.custom<CertificateType>(),
  timeFrame: z
    .object({
      from: z.date({ error: "common.fieldErrorList.requiredField" }),
      to: z.date().optional(),
    })
    .superRefine((data, ctx) => {
      if (!data.to || (data?.to && isBefore(data.to, data.from))) {
        ctx.addIssue({
          code: "custom",
          path: ["to"],
          message: "common.fieldErrorList.invalidDateRange",
        })
      }
    }),
})

export type SickLeaveCertificateType = z.infer<typeof SickLeaveCertificateSchema>
